import { z } from "zod";

const conjunctionFilterKeySchema = z.enum(["and_filter", "or_filter"]);
const filterKeySchema = z.literal("category_filter");

// Filter Result Schema
export const messagePrioritizationRuleFilterResultSchema = z.object({
  filter_key: z.string(),
  display_name: z.string(),
  comparison_key: z.string(),
  value: z.unknown().optional(),
});

// Filter Group Result Schema
export const messagePrioritizationRuleFilterGroupResultSchema = z.object({
  filter_key: conjunctionFilterKeySchema,
  filters: z.array(messagePrioritizationRuleFilterResultSchema),
});

// Top-level Result schema
export const postMessagePrioritizationRulesResultSchema = z.object({
  rules: z.array(
    z.object({
      name: z.string(),
      description: z.string().optional(),
      campaign_filters: z.object({
        filter_key: conjunctionFilterKeySchema,
        filters: z.array(messagePrioritizationRuleFilterGroupResultSchema),
      }),
    })
  ),
});

// Filter Props Schema
export const messagePrioritizationRuleFilterPropsSchema = z.object({
  filterKey: filterKeySchema,
  comparisonKey: z.string(),
  value: z.unknown(),
});

// Filter Group Props Schema
export const messagePrioritizationRuleFilterGroupPropsSchema = z.object({
  filterKey: conjunctionFilterKeySchema,
  filters: z.array(messagePrioritizationRuleFilterPropsSchema),
});

// Top-level Props schema
export const postMessagePrioritizationRulesPropsSchema = z.object({
  appGroupId: z.string(),
  id: z.string().optional(),
  unreadChangelogCount: z.number().optional(),
  rules: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
      description: z.string().optional(),
      activeCampaigns: z
        .array(
          z.object({
            id: z.string(),
            name: z.string(),
          })
        )
        .optional(),
      activeCanvases: z
        .array(
          z.object({
            id: z.string(),
            name: z.string(),
          })
        )
        .optional(),
      isEditMode: z.boolean().optional(),
      campaignFilters: z.object({
        filterKey: conjunctionFilterKeySchema,
        filters: z.array(messagePrioritizationRuleFilterGroupPropsSchema),
      }),
    })
  ),
});

export type MessagePrioritizationRuleFilterGroupResult = z.infer<
  typeof messagePrioritizationRuleFilterGroupResultSchema
>;
export type MessagePrioritizationRuleFilterResult = z.infer<typeof messagePrioritizationRuleFilterResultSchema>;
export type PostMessagePrioritizationRulesResult = z.infer<typeof postMessagePrioritizationRulesResultSchema>;
export type ConjunctionFilterKey = z.infer<typeof conjunctionFilterKeySchema>;
export type FilterKey = z.infer<typeof filterKeySchema>;

export type MessagePrioritizationRuleFilterProps = z.infer<typeof messagePrioritizationRuleFilterPropsSchema>;
export type MessagePrioritizationRuleFilterGroupProps = z.infer<
  typeof messagePrioritizationRuleFilterGroupPropsSchema
>;
export type PostMessagePrioritizationRulesProps = z.infer<typeof postMessagePrioritizationRulesPropsSchema>;
